<template>
  <div>
    <el-row :gutter="10">
      <el-col :span="11">
        <BasicsForm
          ref="basicsForm"
          @calcSubmit="calcSubmit"
          :dataInfo="dataInfo"
          :planList="planList"
          :id="id"
          :readOnly="readOnly"
          :beforeBjList="$route.query.beforeBjList || beforeBjList"
          v-if="visible"
        />
      </el-col>

      <el-col :span="13">
        <Frame title="测算值">
          <template slot="contentSlot">
            <div class="con_wrapper">
              <avue-form
                ref="form"
                v-model="calculateForm"
                :option="calculateOption"
              >
              </avue-form>

              <Frame
                title="模拟还款计划"
                :insideFrame="true"
                :typeSameLine="true"
              >
                <template slot="contentSlot">
                  <div class="con_wrapper">
                    <CalcCrud
                      ref="calcCrud"
                      :tableData="planList"
                      :dataInfo="dataInfo"
                      :readOnly="readOnly"
                      :id="id"
                      @submitPlan="submitPlan"
                    />
                  </div>
                </template>
              </Frame>
            </div>
          </template>
        </Frame>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Frame from "./components/frame.vue";
import BasicsForm from "./components/basicsForm.vue";
import CalcCrud from "./components/calcCrud.vue";
import { getQuotaDetail } from "@/api/factoring/factoringScheme";
import * as api from "@/api/factoring/factoringScheme";
import { calculateOption } from "./config";
import { floatAdd } from "@/util/util";
export default {
  name: "addEditScheme",
  data() {
    return {
      calculateOption: calculateOption(),
      dataInfo: {},
      planList: [],
      visible: false,
      basicList: [],
    };
  },
  props: {
    bjId: {
      type: Number,
      default: -1,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    beforeBjList: {
      type: Boolean,
      default: true,
    },
  },

  components: {
    BasicsForm,
    CalcCrud,
    Frame,
  },
  computed: {},

  watch: {
    bjId: {
      handler: async function (val) {
        this.id = val && val > -1 ? val : this.$route.params.bjId;

        this.visible = true;
        if (this.id && this.id > -1) {
          let res = await this.queryDetail(this.id);
          this.handleDataInfo(res);
        }
      },
      immediate: true,
    },
  },
  async mounted() {
    // this.id = this.bjId > -1 ? this.bjId : this.$route.params.bjId;
    // this.visible = true;
    // if (this.id > -1) {
    //   this.visible = true;
    //   let res = await this.queryDetail(this.id);
    //   this.handleDataInfo(res);
    // }
  },
  methods: {
    handleDataInfo(data, emit) {
      let calculateForm = data;
      calculateForm.xirrStr = (Number(calculateForm.xirr) * 100).toFixed(4);
      // calculateForm.tcrStr = (Number(calculateForm.tcr) * 100).toFixed(2);
      calculateForm.totalRevenueStr = Number(
        calculateForm.totalRevenue
      ).toFixed(2);
      calculateForm.quotationPrice = Number(
        calculateForm.quotationPrice
      ).toFixed(2);
      this.dataInfo = calculateForm;
      this.planList = calculateForm.planList;
      this.calculateForm = calculateForm;
    },
    calcSubmit(res, emit) {
      this.id = res.id;
      if (emit == "emit") {
        this.$emit("dataInfo", res);
      } else {
        this.handleDataInfo(res, emit);
        this.planList = res.planList;
      }
    },
    async submitPlan(planList) {
      let form = this.$refs.basicsForm.getData();
      if (form == undefined) {
        return;
      }
      let price = 0;
      // price=add(Number(price),Number(planList[0].principal))
      planList.map((item) => {
        price = floatAdd(Number(price), Number(item.principal));
      });
      if (price != form.quotationPrice) {
        this.$message.error("每期本金总额必须等于融资额度");
        return;
      }
      let data = {
        ...form,
        planList: planList,
      };
      api.calcQuota(data).then(
        (res) => {
          this.$message({
            type: "success",
            message: "操作成功!",
          });

          this.$refs.calcCrud.handleEdit(false);
          this.handleDataInfo(res.data.data);
        },
        (error) => {
          window.console.log(error);
        }
      );
    },
    queryDetail(id) {
      return new Promise(async (resolve, reject) => {
        let res = await getQuotaDetail({ id: id });
        if (res.data.code == 200) {
          resolve(res.data.data);
        } else {
          this.$message({
            type: "warning",
            message: res.data.msg,
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.flex_wrapper {
  display: flex;
  align-items: center;
}
.select-item {
  padding: 0 20px !important;
}
</style>